import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Modal, Tooltip, OverlayTrigger } from 'react-bootstrap';
import DynamicFormModal, { ENTITY_CONFIGS } from '../../../formBuilder/wrappers/DynamicFormModal';
import {
    deletePhysician,
    lockPhysician,
    unLockPhysician
} from '../../../../services/clinicPortalServices/physicianServices';
import { getUserRole } from '../../../../services/common/util';
import Swal from 'sweetalert2';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import { trackRecentView } from '../../../../services/clinicPortalServices/recentViewService';

import RecordDetails from '../../../common/RecordDetails';
export default class EditBtnCellRenderer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            show: false,
            showPanel: false,
            physicianDetails: {},
            physicianId: props.data._id,
            physicianNpi: props.data.npi,
            errors: []
        };
    }

    handleShow = () => {
        this.setState({ show: true });
        // Track recent view
        const physician = this.props.data;
        if (physician) {
            const label = `${physician.first_name || ''} ${physician.last_name || ''} (NPI: ${physician.npi || 'N/A'})`.trim();
            trackRecentView('physician', physician._id, label, '/clinic/physician');
        }
    };

    handleClose = () => {
        this.setState({ show: false });
    };

    handleDelete = () => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this physician!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const physicianInfo = {
                    _id: this.state.physicianId,
                    first_name: this.props.data.first_name,
                    last_name: this.props.data.last_name
                };
                deletePhysician(physicianInfo).then((response) => {
                    this.props.context.componentParent.loadGridData();
                });
            }
        });
    };

    renderTooltipEdit = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Edit Physician
        </Tooltip>
    );

    renderTooltipDelete = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Delete Physician
        </Tooltip>
    );

    renderTooltipLock = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Lock Physician
        </Tooltip>
    );

    lockPhysician = () => {
        Swal.fire({
            title: 'Lock Physician',
            text: 'You are about to lock ' + this.props.data.first_name + ' ' + this.props.data.last_name,
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Yes',
            cancelButtonText: 'No',
            customClass: {
                container:
                    window.localStorage.getItem('appTheme') === 'Dark' &&
                    /clinic|lims/.test(window.location.pathname.split('/')[1]) &&
                    'dark-swal',
                cancelButton: 'order-1',
                confirmButton: 'order-2'
            }
        }).then((result) => {
            if (result.isConfirmed) {
                lockPhysician(this.state.physicianId).then((PhysicianRes) => {
                    this.props.context.componentParent.loadGridData();
                });
            }
        });
    };

    renderTooltipUnLock = (props) => (
        <Tooltip id="button-tooltip" {...props}>
            Release Lockd Physician
        </Tooltip>
    );

    unLockPhysician = () => {
        unLockPhysician(this.state.physicianId).then((PhysicianRes) => {
            this.props.context.componentParent.loadGridData();
        });
    };

    renderPanel() {
        const d = this.props.data;
        const panelStyles = {
            overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1040 },
            panel: { position: 'fixed', top: 0, right: 0, width: '420px', height: '100vh', background: '#fff', boxShadow: '-4px 0 20px rgba(0,0,0,0.15)', zIndex: 1041, display: 'flex', flexDirection: 'column', overflowY: 'auto' },
            header: { padding: '16px 20px', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: '#f8f9fa' },
            title: { margin: 0, fontSize: '16px', fontWeight: 600, color: '#333' },
            body: { padding: '20px', flex: 1 },
            section: { marginBottom: '20px' },
            sectionTitle: { fontSize: '11px', fontWeight: 700, color: '#888', letterSpacing: '0.08em', textTransform: 'uppercase', marginBottom: '10px', paddingBottom: '6px', borderBottom: '1px solid #eee' },
            dl: { display: 'grid', gridTemplateColumns: '140px 1fr', rowGap: '8px', margin: 0 },
            dt: { fontSize: '13px', color: '#555', fontWeight: 600, paddingRight: '8px' },
            dd: { fontSize: '13px', color: '#222', margin: 0 },
            editBtn: { background: '#0066cc', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 14px', fontSize: '13px', cursor: 'pointer', marginRight: '8px' },
            closeBtn: { background: 'transparent', border: 'none', fontSize: '18px', cursor: 'pointer', color: '#666' }
        };
        const fullName = [d.first_name, d.last_name].filter(Boolean).join(' ');
        const facility = Array.isArray(d.facilityId) ? d.facilityId.map(f => f.facility?.name || f.name || f).join(', ') : (d.facilityId?.name || d.facilityId || '—');
        const address = [d.address1, d.address2, d.city, d.state, d.zip].filter(Boolean).join(', ');
        return ReactDOM.createPortal(
            <>
                <div style={panelStyles.overlay} onClick={() => this.setState({ showPanel: false })} />
                <div style={panelStyles.panel}>
                    <div style={panelStyles.header}>
                        <h5 style={panelStyles.title}>Physician Details</h5>
                        <div>
                            {!/customerserviceuser/.test(getUserRole().toLowerCase()) && (
                                <button style={panelStyles.editBtn} onClick={() => { this.setState({ showPanel: false }); this.handleShow(); }}>
                                    <i className="fas fa-pen" style={{ marginRight: 5 }}></i>Edit
                                </button>
                            )}
                            <button style={panelStyles.closeBtn} onClick={() => this.setState({ showPanel: false })}>
                                <i className="fas fa-times"></i>
                            </button>
                        </div>
                    </div>
                    <div style={panelStyles.body}>
                        <div style={panelStyles.section}>
                            <div style={panelStyles.sectionTitle}>Physician Information</div>
                            <dl style={panelStyles.dl}>
                                <dt style={panelStyles.dt}>Name</dt>
                                <dd style={panelStyles.dd}>{fullName || '—'}</dd>
                                <dt style={panelStyles.dt}>NPI</dt>
                                <dd style={panelStyles.dd}>{d.npi || '—'}</dd>
                                <dt style={panelStyles.dt}>Mobile</dt>
                                <dd style={panelStyles.dd}>{d.mobile || '—'}</dd>
                                <dt style={panelStyles.dt}>Status</dt>
                                <dd style={panelStyles.dd}>{d.locked === 'locked' ? 'Locked' : 'Active'}</dd>
                                <dt style={panelStyles.dt}>Facility</dt>
                                <dd style={panelStyles.dd}>{facility}</dd>
                            </dl>
                        </div>
                        {address && (
                            <div style={panelStyles.section}>
                                <div style={panelStyles.sectionTitle}>Address</div>
                                <div style={{ fontSize: '13px', color: '#222' }}>{address}</div>
                            </div>
                        )}
                    
                        <RecordDetails data={d} exclude={['address1', 'address2', 'city', 'facilityId', 'first_name', 'last_name', 'locked', 'mobile', 'npi', 'state', 'zip', 'results', 'password', 'token', 'resetPasswordToken', 'refreshToken']} />
                    </div>
                </div>
            </>,
            document.body
        );
    }

    render() {
        return (
            <div>
                <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={<Tooltip id="button-tooltip">View Physician</Tooltip>}>
                    <button onClick={() => this.setState({ showPanel: true })} className="edit-order-btn">
                        <i className="fas fa-eye"></i>
                    </button>
                </OverlayTrigger>
                {this.state.showPanel && this.renderPanel()}
                {!/customerserviceuser/.test(getUserRole().toLowerCase()) && (
                    <OverlayTrigger placement="top" delay={{ show: 50, hide: 100 }} overlay={this.renderTooltipEdit}>
                        <button onClick={this.handleShow} className="edit-order-btn">
                            <i className="fas fa-pen"></i>
                        </button>
                    </OverlayTrigger>
                )}
                {/* {
					!(/customerserviceuser/.test(getUserRole().toLowerCase())) &&
					<OverlayTrigger
						placement="top"
						delay={{ show: 50, hide: 100 }}
						overlay={this.renderTooltipDelete}
					>
						<button onClick={this.handleDelete} className="edit-order-btn">
							<i className="fas fa-trash"></i>
						</button>
					</OverlayTrigger>
				} */}

                {!/customerserviceuser|^admin/.test(getUserRole().toLowerCase()) && (
                    <>
                        {this.props.data.locked === 'locked' && (
                            <>
                                <OverlayTrigger
                                    placement="top"
                                    delay={{ show: 50, hide: 100 }}
                                    overlay={this.renderTooltipUnLock}
                                >
                                    <button onClick={this.unLockPhysician} className="edit-order-btn">
                                        <i className="fas fa-lock-open"></i>
                                    </button>
                                </OverlayTrigger>
                            </>
                        )}
                        {this.props.data.locked !== 'locked' && (
                            <OverlayTrigger
                                placement="top"
                                delay={{ show: 50, hide: 100 }}
                                overlay={this.renderTooltipLock}
                            >
                                <button onClick={this.lockPhysician} className="edit-order-btn">
                                    <i className="fas fa-lock"></i>
                                </button>
                            </OverlayTrigger>
                        )}
                    </>
                )}
                <ModalStyled
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    show={this.state.show}
                    onHide={this.handleClose}
                    backdrop="static"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Update Physician Information</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <DynamicFormModal
                            entityType="physician"
                            entityId={this.state.physicianId}
                            entityConfig={ENTITY_CONFIGS.physician}
                            context={this.props.context}
                            handleClose={this.handleClose}
                        />
                    </Modal.Body>
                </ModalStyled>
            </div>
        );
    }
}
